/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Onboarding_Verify_Code_SentInputs */

const en_onboarding_verify_code_sent = /** @type {(inputs: Onboarding_Verify_Code_SentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Verification code sent to ${i?.email}`)
};

const de_onboarding_verify_code_sent = /** @type {(inputs: Onboarding_Verify_Code_SentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bestätigungscode an ${i?.email} gesendet`)
};

const fr_onboarding_verify_code_sent = /** @type {(inputs: Onboarding_Verify_Code_SentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Code de vérification envoyé à ${i?.email}`)
};

const es_onboarding_verify_code_sent = /** @type {(inputs: Onboarding_Verify_Code_SentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Código de verificación enviado a ${i?.email}`)
};

const it_onboarding_verify_code_sent = /** @type {(inputs: Onboarding_Verify_Code_SentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Codice di verifica inviato a ${i?.email}`)
};

const nl_onboarding_verify_code_sent = /** @type {(inputs: Onboarding_Verify_Code_SentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Verificatiecode verzonden naar ${i?.email}`)
};

const pl_onboarding_verify_code_sent = /** @type {(inputs: Onboarding_Verify_Code_SentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kod weryfikacyjny wysłany na ${i?.email}`)
};

const fi_onboarding_verify_code_sent = /** @type {(inputs: Onboarding_Verify_Code_SentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vahvistuskoodi lähetetty osoitteeseen ${i?.email}`)
};

const da_onboarding_verify_code_sent = /** @type {(inputs: Onboarding_Verify_Code_SentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bekræftelseskode sendt til ${i?.email}`)
};

const sv_onboarding_verify_code_sent = /** @type {(inputs: Onboarding_Verify_Code_SentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Verifieringskod skickad till ${i?.email}`)
};

/**
* | output |
* | --- |
* | "Verification code sent to {email}" |
*
* @param {Onboarding_Verify_Code_SentInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const onboarding_verify_code_sent = /** @type {((inputs: Onboarding_Verify_Code_SentInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Verify_Code_SentInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_onboarding_verify_code_sent(inputs)
	if (locale === "fr") return fr_onboarding_verify_code_sent(inputs)
	if (locale === "es") return es_onboarding_verify_code_sent(inputs)
	if (locale === "it") return it_onboarding_verify_code_sent(inputs)
	if (locale === "nl") return nl_onboarding_verify_code_sent(inputs)
	if (locale === "pl") return pl_onboarding_verify_code_sent(inputs)
	if (locale === "fi") return fi_onboarding_verify_code_sent(inputs)
	if (locale === "da") return da_onboarding_verify_code_sent(inputs)
	if (locale === "sv") return sv_onboarding_verify_code_sent(inputs)
	return en_onboarding_verify_code_sent(inputs)
});